import GfcrIndicatorSet from './GfcrIndicatorSet'

export default GfcrIndicatorSet
